import axios from "axios";

export interface AccountRecoveryResponse {
  name: string;
  email: string;
  role: string;
}

export interface AccountRecoveryError {
  message: string;
}

export type AccountRecoveryRole = "director" | "coach" | "student";

export type AccountRecoveryRequest =
  | { email: string }
  | {
      firstName: string;
      lastName: string;
      role: AccountRecoveryRole;
    };

export async function requestAccountRecovery(
  payload: AccountRecoveryRequest,
): Promise<AccountRecoveryResponse> {
  const baseURL = (process.env.REACT_APP_API_URI || "").replace(/\/$/, "");
  const body =
    "email" in payload
      ? { email: payload.email.trim().toLowerCase() }
      : {
          firstName: payload.firstName.trim(),
          lastName: payload.lastName.trim(),
          role: payload.role,
        };

  const response = await axios.post<AccountRecoveryResponse>(
    `${baseURL}/api/users/account-recovery`,
    body,
  );
  return response.data;
}
